module.exports = __webpack_public_path__ + "img/checked.7cb51b41.svg";